module.exports = __webpack_public_path__ + "static/media/063.78cd7ed6.jpg";